<template>
  <div id="modal" class="modal order_disp_modal" v-show="modalShown">
    <div class="modal-main modal-container" id="order_disp_modal">
      <div class="modal-header">表示項目</div>
      <div class="search_content">
        <div class="container search_li">
          <div class="search_th">注文情報</div>
          <div class="search_td container flex-wrap order_info">
            <div v-for="(order, index) in orderList" :key="'order' + index">
              <input type="checkbox" :id="'dc_' + index" @click="setCheck($event, order.order)"
                v-model="dispForm.checkList" v-bind:value="order.order"/>
              <label :for="'dc_' + index">{{order.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">商品情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(product, index) in productList" :key="'product' + index">
              <input type="checkbox" :id="'prod_' + index" @click="setCheck($event, product.order)"
                v-model="dispForm.checkList" v-bind:value="product.order"/>
              <label :for="'prod_' + index">{{product.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">納品先情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(delivery, index) in deliveryList" :key="'delivery' + index">
              <input type="checkbox" :id="'nohin_' + index" @click="setCheck($event, delivery.order)"
                v-model="dispForm.checkList" v-bind:value="delivery.order"/>
              <label :for="'nohin_' + index">{{delivery.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">配送情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(delicorp, index) in deliCorpList" :key="'delicorp' + index">
              <input type="checkbox" :id="'deli_' + index" @click="setCheck($event, delicorp.order)"
                v-model="dispForm.checkList" v-bind:value="delicorp.order"/>
              <label :for="'deli_' + index">{{delicorp.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">組立設置情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(construct, index) in constructList" :key="'construct' + index">
              <input type="checkbox" :id="'const_' + index" @click="setCheck($event, construct.order)"
                v-model="dispForm.checkList" v-bind:value="construct.order"/>
              <label :for="'const_' + index">{{construct.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">注文者情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(orderUser, index) in orderUserList" :key="'orderUser' + index">
              <input type="checkbox" :id="'customer_' + index" @click="setCheck($event, orderUser.order)"
                v-model="dispForm.checkList" v-bind:value="orderUser.order"/>
              <label :for="'customer_' + index">{{orderUser.label}}</label>
            </div>
          </div>
        </div>
        <div class="container search_li">
          <div class="search_th">事前現場調査情報</div>
          <div class="search_td container flex-wrap">
            <div v-for="(research, index) in researchList" :key="'research' + index">
              <input type="checkbox" :id="'surveyinfo_' + index" @click="setCheck($event, research.order)"
                v-model="dispForm.checkList" v-bind:value="research.order"/>
              <label :for="'surveyinfo_' + index">{{research.label}}</label>
            </div>
          </div>
        </div>
      </div>
        <div class="modal-footer">
          <button class="main_btn pos_left" @click="defaultDisp()">デフォルト</button>
          <button class="main_btn pos_right" @click="close()">閉じる</button>
          <button class="main_btn search_btn" @click="disp()">適用</button>
        </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'orderDispModal',
  components: {
  },
  props: {
    onDisp: {
      type: Function,
      default: function () {}
    },
    /** コールバックに渡す引数 */
    callbackParams: {
      type: Object,
      default: function () { return {} }
    },
    refDispForm: Object,
    defaultDispForm: Array
  },
  data () {
    return {
      dispForm: {
        checkList: []
      },
      modalShown: false,
      orderList: [
        {order: 0, label: '注文番号'},
        {order: 1, label: '注文個別番号'},
        {order: 2, label: 'サービス名'},
        {order: 3, label: 'プランID'},
        {order: 4, label: 'ステータス'},
        {order: 5, label: '更新者'},
        {order: 6, label: '受注日時'},
        {order: 7, label: '決済方法'},
        {order: 8, label: '支払期日'},
        {order: 9, label: '支払ご確認日'},
        {order: 10, label: 'ご請求額（税抜）'},
        {order: 11, label: 'ご請求額（税込）'}
      ],
      productList: [
        {order: 12, label: 'シリーズ名'},
        {order: 13, label: '商品名'},
        // {order: 12, label: 'プラン名'},
        {order: 14, label: 'Wサイズ'},
        {order: 15, label: 'Hサイズ'},
        {order: 16, label: 'Dサイズ'},
        {order: 17, label: 'W2サイズ'},
        {order: 18, label: 'H2サイズ'},
        {order: 19, label: 'D2サイズ'},
        {order: 20, label: '扉カラー'},
        {order: 21, label: 'キャビネット/棚/脚カラー'},
        {order: 22, label: 'カウンターカラー'},
        {order: 23, label: '組立設置'},
        {order: 24, label: '受け取り搬入サービス'},
        {order: 25, label: '出品メーカー'}
      ],
      deliveryList: [
        {order: 26, label: '施主名（物件名）'},
        {order: 27, label: '納品先名'},
        {order: 28, label: '受取人氏名'},
        {order: 29, label: '受取人電話番号'},
        {order: 30, label: '納品先住所'},
        {order: 31, label: '希望納品日'},
        {order: 32, label: '確定納品日'}
      ],
      deliCorpList: [
        {order: 33, label: 'PF納品日'},
        {order: 34, label: 'お客様納品日'},
        {order: 35, label: '商品個口数'}
      ],
      constructList: [
        {order: 36, label: '立会人氏名'},
        {order: 37, label: '立会人電話番号'},
        {order: 38, label: '組立設置先'},
        {order: 39, label: '確定組立設置日'},
        {order: 40, label: 'ご自宅のタイプ'},
        {order: 41, label: '駐車スペースの有無'}
      ],
      orderUserList: [
        {order: 42, label: '発注者名'},
        {order: 43, label: '会社名'},
        {order: 44, label: '所属部署'},
        {order: 45, label: '発注者電話番号'},
        {order: 46, label: '知ったメディア'},
        {order: 47, label: '招待コード'}
      ],
      researchList: [
        {order: 48, label: '調査物件名'},
        {order: 49, label: '立会人氏名'},
        {order: 50, label: '立会人電話番号'},
        {order: 51, label: '確定事前調査日'},
        {order: 52, label: '事前現場調査依頼者の当日立ち合い'}
      ]
    }
  },
  watch: {
  },
  methods: {
    showModal: function () {
      this.modalShown = true
    },
    disp: function () {
      this.modalShown = false
      this.callbackParams.dispForm = this.dispForm
      this.onDisp(this.callbackParams)
    },
    defaultDisp: function () {
      this.dispForm.checkList = this.defaultDispForm
    },
    close: function () {
      this.modalShown = false
    },
    setCheck: function (event, order) {
      if (event.target.checked === true) {
        this.dispForm.checkList.push(order)
      } else {
        this.dispForm.checkList = this.dispForm.checkList.filter(s => s !== order)
      }
    }
  },
  computed: {
  },
  mounted: function () {
  },
  created: function () {
    this.dispForm.checkList = this.refDispForm.checkList.slice()
  }
}
</script>
<style src="../../css/order/order_search.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/components/order/OrderDispModal.vue